import styled from 'styled-components'

export const LayoutFull = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;
`

export const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  height: 100%;
  width: 100%;
`
export const Loader = styled.img`
  width: 3rem;
  height: 3rem;
`
